
import PromoIconWrapper from 'Src/js/components/promos/PromoIconWrapper.vue';
import { defineComponent, PropType } from 'vue';
import { OfferDisplayType } from 'JS/helpers/promo-helpers';

export default defineComponent({
	name: 'PromoOfferDiscountLine',
	components: {
		PromoIconWrapper,
	},
	props: {
		type: { type: String as PropType<OfferDisplayType>, default: 'normal' },
		description: { type: String, required: true },
		amount: String,
		monochrome: Boolean,
		amountIsHidden: Boolean,
	},
});
